/**
 * Whitelists all MadCap nodes.
 * Uses a case-insensitive comparison to check the node name.
 * @param node The node to check.
 * @returns `true` if the node's name starts with 'MadCap:'.
 */
export function flareElementEmptyNodeWhitelistMatcher(node: Element): boolean {
  return node.nodeName.toLowerCase().startsWith('madcap:');
}
